import React from "react";
import "react-calendar/dist/Calendar.css";
import "react-datepicker/dist/react-datepicker.css";
import { I18nextProvider } from "react-i18next";
import "react-perfect-scrollbar/dist/css/styles.css";
import "react-phone-input-2/lib/style.css";
import MainLayout from "./Containers/MainLayout";
import GlobalThemeProvider from "./Helpers/Themes/themeProvider";
import { AuthContextProvider } from "./Helpers/Contexts/authContext";
import i18next from "i18next";
import KenLoader from "./GlobalComponents/KenLoader";
import { ErrorBoundary } from "react-error-boundary";
import ErrorFallback from "./Helpers/ErrorFallback";
import { FormContextProvider } from "./Helpers/Contexts/formContext";
import { LocalizationProvider } from "@mui/x-date-pickers";
import { AdapterMoment } from "@mui/x-date-pickers/AdapterMoment";
import AppSnackBar from "./Components/AppSnackbar";
import "./App.css";
import { CourseContentProvider } from "./Helpers/Contexts/courseContext";
import { getAxiosInstance } from "./Utils/apiService";

function App() {
  getAxiosInstance();

  return (
    <div className="App">
      <React.Suspense fallback={<KenLoader />}>
        <ErrorBoundary
          FallbackComponent={ErrorFallback}
          onReset={() => {
            window.location.reload();
          }}
        >
          <LocalizationProvider dateAdapter={AdapterMoment}>
            <I18nextProvider i18n={i18next}>
              <AppSnackBar>
                <AuthContextProvider>
                  <CourseContentProvider>
                    <FormContextProvider>
                      <GlobalThemeProvider>
                        <MainLayout />
                      </GlobalThemeProvider>
                    </FormContextProvider>
                  </CourseContentProvider>
                </AuthContextProvider>
              </AppSnackBar>
            </I18nextProvider>
          </LocalizationProvider>
        </ErrorBoundary>
      </React.Suspense>
    </div>
  );
}

export default App;
